supplierId = 2;


//////////////////
// WEBPACK FOOTER
// ./config/supplier.env.js
// module id = BIuL
// module chunks = 1